import { useGetPermissions } from 'api-hooks/auth/query';
import { AuthorizationRules } from 'common/constants/authorization-rules';
import * as React from 'react';

export function useAuthorization() {
  const { data } = useGetPermissions();
  const can = React.useCallback(
    (rule: AuthorizationRules) =>
      rule === AuthorizationRules.NoAuthorization
        ? true
        : !!(data?.data || [])?.includes(rule),
    [data?.data],
  );

  return {
    can,
  };
}
